const AUTH_STORAGE_KEY = 'cinemahala_active_user';

export const authService = {
  getCurrentUser() {
    try {
      const raw = localStorage.getItem(AUTH_STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  },

  isLoggedIn() {
    return !!this.getCurrentUser();
  },

  isAdmin() {
    const user = this.getCurrentUser();
    return user && user.role === 'admin';
  },

  isMember() {
    const user = this.getCurrentUser();
    return user && user.role === 'member';
  },

  login(email, password = '') {
    const trimmed = (email || '').trim().toLowerCase();
    
    // Check if admin email matches the owner
    const isAdminUser = trimmed === 'dmsameeram@gmail.com' || trimmed === 'admin@cinemahala.lk';

    const user = {
      id: isAdminUser ? 'admin_samseen' : 'user_' + Math.random().toString(36).substring(2, 9),
      email: trimmed,
      name: isAdminUser ? 'SamSeen Admin' : (trimmed.split('@')[0] || 'Film Cinephile'),
      role: isAdminUser ? 'admin' : 'member',
      avatar: isAdminUser 
        ? 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=200&q=80'
        : 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=200&q=80',
      loginAt: Date.now()
    };

    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user));
    window.dispatchEvent(new CustomEvent('auth-changed', { detail: user }));
    return user;
  },

  register(email, name) {
    const trimmed = (email || '').trim().toLowerCase();
    const user = {
      id: 'user_' + Math.random().toString(36).substring(2, 9),
      email: trimmed,
      name: (name || '').trim() || trimmed.split('@')[0],
      role: 'member',
      avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=200&q=80',
      loginAt: Date.now()
    };

    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user));
    window.dispatchEvent(new CustomEvent('auth-changed', { detail: user }));
    return user;
  },

  logout() {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    window.dispatchEvent(new CustomEvent('auth-changed', { detail: null }));
  }
};
